import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import PublicLayout from 'web/components/PublicLayout';
import Layout from "web/components/Layout";
import PalletSupply from 'web/pages/public/landing-page/WhoItFor/PalletSupply'
import PalletSellers from 'web/pages/public/landing-page/WhoItFor/PalletSellers'
import PalletBuyers from 'web/pages/public/landing-page/WhoItFor/PalletBuyers'
import PalletBroker from "web/pages/public/landing-page/WhoItFor/PalletBroker"
import LandingFooter from "web/pages/public/landing-page/LandingFooter";

const WhoItFor = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet title="The Ultimate Marketplace for Pallets Buyers & Sellers Online | PalletTrader.">
      <meta name="description"
    content="PalletTrader is the onestop online marketplace for selling pallets, buying pallets or controlling pallets supply on your terms. Ultimate tool for pallet trading." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/who-its-for" />
      </Helmet>
      {localStorage.getItem("token") ? <Layout transparentHeader={false} topBarViewMobile={"hide"}>
      <PalletSupply />
        <PalletSellers />
        <PalletBuyers />
        <PalletBroker />
        {/* <LandingFooter isBackgroundWhite={true} /> */}
</Layout> :  <PublicLayout transparentHeader={true}>
        <PalletSupply />
        <PalletSellers />
        <PalletBuyers />
        <PalletBroker />
        <LandingFooter isBackgroundWhite={true} />
      </PublicLayout> }


    </>
  );
}
export default WhoItFor;
